
import {baseUrl} from '@/api/config.js'

export default{
    
    userinfo:baseUrl+`/official/userinfo`,   //userinfo
    docharge:baseUrl+`/official/docharge`,   //docharge
    cataloglist:baseUrl+`/official/catalog/list`,   //cataloglist
    arealist:baseUrl+`/official/area/list`,   //arealist
    trackDeletion:baseUrl+`/facebook/trackDeletion`,   //trackDeletion

};


// WEBPACK FOOTER //
// ./src/api/api_config.js